<template>
  <el-dialog class="dialog-container" @close="handleClose" title="验证优惠劵" :visible.sync="dialogVisible">
    <div class="dialog-search-btn">
      <el-input v-model="value" clearable placeholder="请输入兑换码"></el-input>
      <el-button type="primary" icon="el-icon-search" @click="clickSearch" size="medium">查询</el-button>
    </div>
    <template v-if="isShowInfo">
      <el-divider content-position="left">优惠劵信息</el-divider>
      <span v-if="memberInfo.member_name !==''" style="margin-left:85px;" class="span-divider">姓名：{{memberInfo.member_name}}</span>
      <span v-else style="margin-left:85px;" class="span-divider">姓名：{{memberInfo.member_wxname}}</span>
      <span class="span-divider">ID：{{memberInfo.member_mid}}</span>
      <span class="span-divider">手机号：{{memberInfo.member_mobile}}</span><br />
      <span class="span-divider" style="margin-left:85px;margin-top:15px;">优惠劵名：{{memberInfo.coupon_name}}</span><br />
      <span class="span-divider" style="margin-left:85px;margin-top:15px;">获取方式：{{memberInfo.coupon_description}}</span>
      <span class="span-divider" style="margin-left:85px;margin-top:15px;">有效时间：{{memberInfo.starttime}} ~ {{memberInfo.endtime}}</span>
    </template>
    <span slot="footer" class="dialog-footer">
      <el-checkbox v-if="isShowInfo" style="margin-right:20px;" v-model="checked">确认优惠劵的信息</el-checkbox>
      <el-button type="primary" :disabled="!checked" @click="handleVerifyAffirm">兑 换</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { searchCoupon, verifyCoupon } from '@/views/webpc/CashierDesk/RealApp/apis'
export default {
  data () {
    return {
      value: '',
      checked: false,
      memberInfo: {},
      isShowInfo: false,
      dialogVisible: false
    }
  },
  methods: {
    show () {
      this.dialogVisible = true
    },
    // 兑换金额
    getHandleVerify () {
      let data = new FormData()
      data.append('cdkey', this.memberInfo.cdkey)
      verifyCoupon(data)
        .then(result => {
          if (result) {
            this.dialogVisible = false
            this.$message({
              type: 'success',
              message: '操作成功!'
            })
          }
        })
    },
    // 兑换触发
    handleVerifyAffirm () {
      this.$confirm('确认兑换优惠劵, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.getHandleVerify()
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    // 查询优惠劵
    clickSearch () {
      this.memberInfo = {}
      this.isShowInfo = false
      this.checked = false
      if (this.value === '') {
        this.$message({
          type: 'warning',
          message: '请输入兑换码'
        })
        return
      }
      let data = new FormData()
      data.append('cdkey', this.value)
      searchCoupon(data)
        .then(result => {
          if (result) {
            if (result.data) {
              this.isShowInfo = true
              this.memberInfo = result.data
            } else {
              this.$confirm('查无数据，请确认输入兑换码是否正确！', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
              }).catch(() => {
              })
            }
          }
        })
    },
    handleClose () {
      this.value = ''
      this.checked = false
      this.memberInfo = {}
      this.isShowInfo = false
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/webpc/CashierDesk/RealApp/modules/verifyModal.vue